"use strict";
function escapeRegexp(queryToEscape) {
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}
exports.escapeRegexp = escapeRegexp;



//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/ng2-select/select/common.js
// module id = ../../../../ng2-select/select/common.js
// module chunks = 4